import { captureFormats } from './constants';

export const getCaptureConfig = ({ gatewayType, gatewaySerialNumber, iotDeviceId, asset, gatewayInformation }) => {
    const resolvedGatewayType = gatewayType || gatewayInformation?.gatewayInfo?.gatewayType;
    switch (resolvedGatewayType) {
        case 'NETA-21':
            return { captureFormat: captureFormats.NETA21, partitionKey: gatewaySerialNumber, dcuSerialNumber: gatewaySerialNumber, assetId: null, assetSerialNumber: null, dcpSerialNumber: null };
        case 'EGW-02':
            return { captureFormat: captureFormats.IOT, partitionKey: null, dcuSerialNumber: iotDeviceId, assetId: null, assetSerialNumber: null, dcpSerialNumber: null };
        case 'DCP':
            return { captureFormat: captureFormats.IOT, partitionKey: null, dcuSerialNumber: iotDeviceId, assetId: null, assetSerialNumber: null, dcpSerialNumber: gatewaySerialNumber };
        case 'Cassia':
        case 'Aruba':
        case 'MachSenseR':
            return { captureFormat: captureFormats.SmartSensor, partitionKey: gatewaySerialNumber, dcuSerialNumber: gatewaySerialNumber, assetId: asset?.assetId, assetSerialNumber: asset?.serialNumber, dcpSerialNumber: null };
        default:
            return { captureFormat: captureFormats.Generic, partitionKey: gatewaySerialNumber, dcuSerialNumber: gatewaySerialNumber, assetId: null, assetSerialNumber: null, dcpSerialNumber: null };
    }
};
